import React, { useEffect } from "react";
import "./IntroPage.style.css";
import ExpandableCard from "../../Components/ExpandableCard/ExpandableCard";
import Data from "../../Assets/Content/ContentData.js";
import EconomySwitch from "../../Components/EconomySwitch/EconomySwitch";

// Import images
import kreisImg from "../../Assets/Images/kreis.png"; // For Kreislaufwirtschaft
import linieImg from "../../Assets/Images/linie.png"; // For Linearwirtschaft

const IntroPage = (props) => {
  const { economyType } = props.AppStateService;
  const { activeCard, circularEconomyState, onChangeEconomySwitch } = props;

  useEffect(() => {
    document.title = "Kreislaufwirtschafts-Guide | Intro";
  }, []);

  const isLinear = economyType === "linear";

  const cardsData = [
    {
      key: "Main",
      title: isLinear ? Data.LinearMain.heading : Data.CycleMain.heading,
      image: isLinear ? linieImg : kreisImg,
      video: isLinear
        ? null
        : process.env.PUBLIC_URL +
          "/Videos/Was_ist_Kreislaufwirtschaft_Final.mp4",
      content: isLinear ? Data.LinearMain.text : Data.CycleMain.text,
      layout: "three-column",
    },
    {
      key: "Rohstoffe",
      title: "Rohstoffe",
      image: kreisImg,
      content: Data.Rohstoffe.text,
      video: process.env.PUBLIC_URL + "/Videos/MDZ Video_Rueckgewinnung.mp4",
      aiContent: Data.Rohstoffe.aiText,
      exampleContent: Data.Rohstoffe.example,
    },
    {
      key: "EcoDesign",
      title: "Eco-Design",
      image: kreisImg,
      content: Data.EcoDesign.text,
      video: process.env.PUBLIC_URL + "/Videos/MDZ Video_ecodesign.mp4",
      aiContent: Data.EcoDesign.aiText,
      exampleContent: Data.EcoDesign.example,
    },
    {
      key: "Produktion",
      title: "Produktion",
      image: kreisImg,
      content: Data.Produktion.text,
      aiContent: Data.Produktion.aiText,
      examplesContent: Data.Produktion.examples,
    },
    {
      key: "Vertrieb",
      title: "Vertrieb",
      image: kreisImg,
      content: Data.Vertrieb.text,
      aiContent: Data.Vertrieb.aiText,
      exampleContent: Data.Vertrieb.example,
    },
    {
      key: "Nutzung",
      title: "Nutzung",
      image: kreisImg,
      content: Data.Nutzung.text,
      video: process.env.PUBLIC_URL + "/Videos/MDZ Video_Nutzung.mp4",
      aiContent: Data.Nutzung.aiText,
      exampleContent: Data.Nutzung.example,
    },
    {
      key: "Nutzungsende",
      title: "Nutzungsende",
      image: kreisImg,
      content: Data.Nutzungsende.text,
      aiContent: Data.Nutzungsende.aiText,
      exampleContent: Data.Nutzungsende.example,
    },
    {
      key: "Recycling",
      title: "Recycling",
      image: kreisImg,
      content: Data.Recycling.text,
      video: process.env.PUBLIC_URL + "/Videos/MDZ Video_Recycling.mp4",
      aiContent: Data.Recycling.aiText,
      exampleContent: Data.Recycling.example,
    },
  ];

  return (
    <div className="container mt-4 mb-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          {cardsData.map((card, index) => (
            <ExpandableCard
              key={index}
              title={card.title}
              content={card.content}
              image={card.image}
              video={card.video}
              aiContent={card.aiContent}
              exampleContent={card.exampleContent}
              examplesContent={card.examplesContent}
              initiallyOpen={activeCard ? card.key === activeCard : index === 0} // Open active card if set, otherwise first card
              layout={card.layout}
            >
              {card.key === "Main" ? (
                <>
                  <div className="mb-3">
                    <EconomySwitch
                      onChangeEconomySwitch={onChangeEconomySwitch}
                      circularEconomyState={circularEconomyState}
                    />
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: card.content }} />
                </>
              ) : null}
            </ExpandableCard>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IntroPage;
